const PLCStatus = {
  NotOnboarded: "not-onboarded",
  Active: "active",
  Hidden: "hidden",
  Deactivated: "deactivated",
};

export default PLCStatus;
